import { Button, useTheme } from "@mui/material";
import axios from "../../utils/axios.tsx";
import SubscriptionIcon from "../icons/SubscriptionIcon";
import { Trans } from "@lingui/react/macro";

const ViewSubscriptionButton = () => {
  const theme = useTheme();

  const handleBillingPortal = async () => {
    try {
      const { data } = await axios.get("/v1/billing/portal/");
      window.open(data.url, "_blank");
    } catch (error) {
      console.error("Error accessing billing portal:", error);
    }
  };

  return (
    <Button
      onClick={handleBillingPortal}
      startIcon={<SubscriptionIcon sx={{ marginLeft: "2px" }} />}
      sx={{
        margin: 2,
        color: theme.palette.common.black,
        width: "200px",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
        justifyContent: "flex-start",
        textAlign: "left",
        textTransform: "none",
        fontSize: "1rem",
      }}
    >
      <Trans context={"Button used to view the subscription in the drawer"}>
        View Subscription
      </Trans>
    </Button>
  );
};

export default ViewSubscriptionButton;
